import type { AppAlertDialogItem, AppAlertDialogState } from "@/types";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const initialState: AppAlertDialogState = {
  appAlertDialogs: [],
};

const AppAlertDialogSlice = createSlice({
  name: "app-alert-dialog",
  initialState,
  reducers: {
    setAppAlertDialogs: (
      state,
      action: PayloadAction<AppAlertDialogItem[]>,
    ) => {
      state.appAlertDialogs = action.payload;
    },
    enqueueAppAlertDialog: (
      state,
      action: PayloadAction<AppAlertDialogItem>,
    ) => {
      state.appAlertDialogs.push(action.payload);
    },
    dequeueAppAlertDialog: (state) => {
      state.appAlertDialogs.shift();
    },
    clearAppAlertDialogs: (state) => {
      state.appAlertDialogs = [];
    },
  },
});

export const {
  setAppAlertDialogs,
  enqueueAppAlertDialog,
  dequeueAppAlertDialog,
  clearAppAlertDialogs,
} = AppAlertDialogSlice.actions;

export default AppAlertDialogSlice.reducer;
